import React from 'react';

import { OfferingMenuPermissions } from '../types';

export const OfferingMenuPermissionsContext = React.createContext<OfferingMenuPermissions>({
  catalogCreate: false,
  catalogRead: false,
  categoryImages: false,
  csvItemImport: false,
  csvItemUpdate: false,
  csvItemPriceUpdate: false,
  customCommissionEdit: false,
  customCommissionRead: false,
  discount: false,
  contentEdit: false,
  exportImport: false,
  itemExportImport: false,
  itemVatChange: false,
  menuSync: false,
  posIdField: false,
  systemIdRead: false,
  woltSpecials: false,
});

export const useOfferingMenuPermissionsContext = () => React.useContext(OfferingMenuPermissionsContext);
